/**
 * @name MenuAdmin
 * @description Menú de acciones de administrador
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

// import { Environment } from '@config';
import { Icons, MUI, Typography } from '@styles';

class MenuAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  openHandler = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  closeHandler = () => {
    this.setState({ anchorEl: null });
  }

  // Redireccionar a la acción de administrador
  goToAction = (path) => {
    this.props.history.push(path);
  }

  render() {
    const { anchorEl } = this.state;
    const { appName, adminActions } = this.props;

    return (
      <>
        {adminActions.length > 0 && (
          <>
            <Styled.BoxTopbarIcon onClick={this.openHandler}>
              <MUI.Tooltip title={i18n.t('Topbar.adminMenu')}>
                <Icons.MoreVert />
              </MUI.Tooltip>
            </Styled.BoxTopbarIcon>

            <Styled.Popover
              open={Boolean(anchorEl)}
              onClose={this.closeHandler}
              anchorEl={anchorEl}
            >
              <Styled.MenuHeader>
                <Styled.BoxHeader>
                  <Typography.Text>
                    {`${i18n.t('GenericMessages.adminOf')} ${appName}`}
                  </Typography.Text>
                </Styled.BoxHeader>
              </Styled.MenuHeader>

              <Styled.BoxAdminActions>
                {adminActions.map((action, i) => (
                  <Styled.MenuItem
                    key={i}
                    onClick={() => this.goToAction(action.route)}
                  >
                    <Typography.Text>
                      {action.label}
                    </Typography.Text>
                  </Styled.MenuItem>
                ))}
              </Styled.BoxAdminActions>
            </Styled.Popover>
          </>
        )}
      </>
    );
  }
}

MenuAdmin.propTypes = {
  // El nombre de aplicación en la que se encuentra.
  appName: PropTypes.string.isRequired,
  // Array de acciones de administrador.
  adminActions: PropTypes.array.isRequired,
  // History router.
  history: PropTypes.object
};

// *************************************
// STYLED COMPONENTS             
// *************************************

const Styled = {};

Styled.BoxTopbarIcon = styled(MUI.ButtonText)`
  &.MuiButton-root{
    display: flex;
    min-width: 60px;
    width: 60px;
    height: 60px;
    padding: 12px;
    margin: 0;

    &:hover {
      text-decoration: none;
      background-color: ${(props) => props.theme.colors.greyHover};
      border-radius: 0%;
    }
  }
`;

Styled.BoxAdminActions = styled.div`
  max-height: 470px;
  overflow-y: auto;
  scrollbar-width: thin !important; /* Scrollbar Firefox */
`;

Styled.BoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

// *************************************
// GLOBAL STYLED COMPONENTS             
// *************************************

Styled.Popover = styled(MUI.Popover)`
  .MuiPopover-paper {
    min-width: 250px;
    max-height: 520px;
    max-width: 608px;
  }
`;

Styled.MenuItem = styled(MUI.MenuItem)`
  &.MuiMenuItem-root {
    height: 50px;
    padding: 0 16px 0 16px;
    &:hover {
      background-color: ${(props) => props.theme.colors.greyHover};
    }
  }
`;

Styled.MenuHeader = styled(MUI.MenuHeader)``;

export default MenuAdmin;